import { ChangeEvent } from 'react';

import CarouselWrapper from '@atom/components/common/photoCarousel/CarouselWrapper';
import { RadioGroup } from '@atom/mui';
import { FormFieldType } from '@atom/types/form';
import { MediaItem } from '@atom/types/media';

import FileUploadButton from '../FileUploadButton';
import FileUploadTile from '../FileUploadTile';

import classes from '../formInstance.module.css';

const { RadioButton } = RadioGroup;

const styles = {
  labelStyles: {
    whiteSpace: 'nowrap',
    paddingLeft: '0.5rem',
  },
};

interface Props {
  field: FormFieldType;
  media: MediaItem[];
  fieldId: string;
  onChange: (value: string) => void;
  removeFile: (mediaId: string, subjectId: string) => void;
  fieldFileUpload: (event: ChangeEvent<HTMLInputElement>) => void;
  renameMedia: (mediaId: string, subjectId: string, name: string) => void;
  value: any;
  isEditable: boolean;
  isUploadDisabled: boolean;
}

const RadioField = ({
  field,
  value,
  removeFile,
  fieldId,
  isEditable,
  fieldFileUpload,
  media,
  isUploadDisabled,
  renameMedia,
  onChange,
}: Props) => {
  const onRadioChange = (event: any): void => {
    if (event.target.value === value) {
      return onChange('');
    }
    return onChange(event.target.value);
  };

  const medium = media.filter((med: MediaItem) => med.fieldId === fieldId);

  return (
    <div className={classes.fieldBlock}>
      <div className={field.required ? classes.required : ''}>
        {field.title}
      </div>
      <div className={classes.fieldDescription}>{field.description}</div>
      <div className={classes.radioContainer}>
        <RadioGroup name="radio" defaultValue={value} onChange={onRadioChange}>
          {field.enum.map((option: string, index: number) => {
            return (
              <RadioButton
                value={option}
                label={option}
                key={index}
                sx={styles.labelStyles}
                disabled={!isEditable}
              />
            );
          })}
        </RadioGroup>
      </div>
      {field.fileUpload && (
        <FileUploadButton
          onChange={fieldFileUpload}
          isUploadDisabled={!isEditable || isUploadDisabled}
        />
      )}
      <div className={classes.fileTileContainer}>
        {medium.map((mediaItem: MediaItem) => (
          <CarouselWrapper
            media={media}
            selectedMediaId={mediaItem.id}
            removeFile={removeFile}
            subjectId={fieldId}
            renameMedia={renameMedia}
            canUpdateMedia={isEditable}
            canDeleteMedia={isEditable}
          >
            <FileUploadTile key={mediaItem.id} media={mediaItem} />
          </CarouselWrapper>
        ))}
      </div>
    </div>
  );
};

export default RadioField;
